;(function($) {	
	$.sgHelpers = $.sgHelpers || {};

	/**
	 * This function encapsulates the access to LocalStorage and SessionStorage and
	 * intercepts DOM errors that occur in browser private modes of a deactivated cookies.
	 * In these cases interaction with those storages are impossible but the calling plugins
	 * will not generate errors.
	 * 
	 * @param {string} type Specifies where the data should be stored. (local | session)
	 * @param {string} action The requested action on the storage object
	 * @param {string} paramOne The first parameter of the requested action
	 * @param {string} paramTwo The second parameter of the requested action 
	 */	

	function _storageWrapper(type, action, paramOne, paramTwo) {
		var storageObject = null,
			result = null,
			length = 0,
			statusStorage = true,
			statusSet = true;

		try {
			// select the requested storage object if it is available
			if (type == 'local' && typeof localStorage == 'object') {
				storageObject = localStorage;
			} else if (type == 'session' && typeof sessionStorage == 'object') {
				storageObject = sessionStorage;
			}
		} catch(e) {
			statusStorage = false;
			console.warn('WebStorage: ' + type + 'Storage not available');
		}

		if (storageObject) {
			try {
				// call the requested function
				switch(action) {
					// the key function is unreliable because it creates verious return values on different browsers
					// so its not implemented in the helpers
					case 'key': 		result = storageObject.key(paramOne); break;
					case 'get': 		result = storageObject.getItem(paramOne); break;
					case 'set': 		result = storageObject.setItem(paramOne, paramTwo); break;
					case 'remove': 		result = storageObject.removeItem(paramOne); break;
					case 'clear': 		result = storageObject.clear(); break;
					case 'length': 		length = storageObject.length; break;
					case 'check_set': 	storageObject.setItem('x', 'x'); storageObject.removeItem('x');
					default: break;
				}	
			} catch(e) {
				statusSet = false;
				console.warn('WebStorage: Function "' + action + '" currently not available');
			}		
		}
		
		if (action == 'check_storage') {return statusStorage;}
		if (action == 'check_set') {return statusSet;}

		return action == 'length' ? length : result;
	};

	/**
	 * The prototype for a custom Storage interface. It can be used like the regular Storage objects,
	 * but has a custom "scope" parameter to store every infomation at a single storage key.
	 * @param {string} type The storage type (local | session)
	 */	

	function _storageHelperPrototype(type) {
		this.length 		= 0;
		this.checkStorage 	= function() {return _storageWrapper(type, 'check_storage');};
		this.checkSetItem 	= function() {return _storageWrapper(type, 'check_set');};
		this.checkScope 	= function() {return _checkJSON;};
		this.getScopedItems = function(scope) {return _getScopeStorage(scope);};
		this.setScopedItems = function(scope, data) {return _checkJSON() ? _processResult(_storageWrapper(type, 'set', scope, JSON.stringify(data)), this) : false;};

		/**
		 * Get the value of a specific item
		 * @param {string} key The storage key of the requested item
		 * @param {string} [scope] If specified the item will be stored in a single storage key
		 */	

		this.getItem = function(key, scope) {
			return scope ? _processScopedItem('get', this, scope, key) : _processResult(_storageWrapper(type, 'get', key), this);
		};

		/**
		 * Set the value of a specific item
		 * @param {string} key The storage key of the requested item
		 * @param {string} value The value that shall be stored in the key
		 * @param {string} [scope] If specified the item will be stored in a single storage key
		 */	

		this.setItem = function(key, value, scope) {
			return scope ? _processScopedItem('set', this, scope, key, value) : _processResult(_storageWrapper(type, 'set', key, value), this);
		};

		/**
		 * Remove a specific item
		 * @param {string} key The storage key of the requested item
		 * @param {string} [scope] If specified the item will be stored in a single storage key
		 */	

		this.removeItem = function(key, scope) {
			return scope ? _processScopedItem('remove', this, scope, key) : _processResult(_storageWrapper(type, 'remove', key), this);		
		};

		/**
		 * Clear the storage / scope
		 * @param {string} [scope] If specified the item will be stored in a single storage key
		 */	

		this.clear = function(scope) {
			return scope ? _processScopedItem('clear', this, scope) : _processResult(_storageWrapper(type, 'clear'), this);
		};

		/**
		 * Count the stored items in a specific scope
		 * @param {string} [scope] If specified the item will be stored in a single storage key
		 */	

		this.scopeLength = function(scope) {
			return _processScopedItem('length', this, scope);
		};

		/**
		 * Process the result of the storage wapper 
		 * @param {object} storageResult The return value of the storage wrapper
		 * @param {object} that A referene to this instance of the class
		 */	

		function _processResult(storageResult, that) {
			// count the storage items
			that.length = _storageWrapper(type, 'length'); 
			return storageResult;
		}

		/**
		 * Process the result of the storage wapper 
		 * @param {string} action The requested action of the scoped mode 
		 * @param {object} that A referene to this instance of the class
		 * @param {string} scope The storage key
		 * @param {string} key Storage key
		 * @param {mixed} value Storage value
		 */	

		function _processScopedItem (action, that, scope, key, value) {
			key = action == 'clear' || action == 'length' ? 'null' : key;

			// check if all data for scoped mode is present
			if (_checkScopeConditions(scope, key)) {
				var storage = _getScopeStorage(scope),
					length = 0;

				switch (action) {
					case 'set': 
						storage[key] = JSON.stringify(value);
						return that.setItem(scope, JSON.stringify(storage));
						break;
					case 'get': 
						return storage[key] ? JSON.parse(storage[key]) : '';
						break;
					case 'remove': 
						if (storage[key]) {
							delete storage[key];
							return that.setItem(scope, JSON.stringify(storage));
						}
						break;
					case 'clear': 
						return that.removeItem(scope);
						break;
					case 'length':
						for (prop in storage) {
							if (storage.hasOwnProperty(prop)) {
		      					length++;
		    				}
						}

						return length;
						break;
					default: break;
				}

			} else {
				return _raiseScopeError(scope, key);
			}
		}

		/**
		 * Get the stored data from the scope
		 * @param {string} scope The storage key
		 */	

		function _getScopeStorage(scope) {
			var item = _storageWrapper(type, 'get', scope);
			return item ? JSON.parse(item) : {};
		}

		function _checkJSON() {
			return JSON ? true : false;
		}

		/**
		 * Check if all data for scoped mode is present
		 * @param {string} scope The storage key
		 * @param {string} key The storage key for the scope
		 */

		function _checkScopeConditions(scope, key) {
			return typeof scope == 'string' && (typeof key == 'string' || typeof key == 'number') ? true : false;
		}

		function _raiseScopeError(scope, key) {
			console.warn('StorageHelper: Wrong params for scope mode - scope: %s | Key: %s', scope, key);
			return false;
		}
	}

	/**
	 * These objects map secure actions to the Storage objects. They provide the usual functions and attributes.
	 */	

	$.sgHelpers.localStorage = new _storageHelperPrototype('local');
	$.sgHelpers.sessionStorage = new _storageHelperPrototype('session');

})(jQuery);


// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-webstorage.js